import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
	selector: 'cjm-tag-group',
	templateUrl: './tag-group.component.html',
	styleUrls: ['./tag-group.component.scss'],
	host: {
		'[class.c-cjm-tag-group]': 'true'
	},
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true
})
export class TagGroupComponent {
	@Input() classes: string = '';
}
